import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';
import * as Popups from '../../constants/popup-types';
import { UpsalePopupStatus } from '../../app/enums';
import { getUpsalePopupStatus, createAnalyticsItemsList, reactParserCommonOptions } from '../../app/functions';
import ReactHtmlParser from 'react-html-parser';

/* actions */
import * as Actions from '../../redux/actions';
import { contentApi } from '../../redux/api/content.api';


class acquireCouponWeb extends baseRequest{

    constructor(benefit = null, translations = {}, onClose = null) {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'acquire Coupon Web';
        this.Config   = new AppConfig();
        this.payload  = null;
        this.benefit  = benefit;
        this.translations = translations;
        this.onClose  = onClose;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload  = payload;
        this.call(this.Config.api.requests.acquireCouponWeb, payload);
    }

    //Parse successful response
    parseResponse(response) {
        // Use the base class logic to determine success/failure
        const isSuccess = this.useNewResponseFormat 
            ? response.statusCode >= 200 && response.statusCode < 300
            : response.status === 1;
            
        if (isSuccess) {
            this.onSuccess(response);
        } else {
            this.onFailure(response);
        }
    }

    onSuccess(response) {
        this.response = { data: response };
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setBenefitAcquired(this.response.data));
        this.dispatch(Actions.setBenefitAcquiredErr(false));
        this.dispatch(Actions.getUserData(false));
        this.dispatch(contentApi.endpoints.getHotYoterStatePanel.initiate(undefined, {
            forceRefetch: true,
        }));
    }

    isHtmlContent(content) {
        return typeof content === 'string' && content.startsWith('<') && content.endsWith('>');
    }
    getErrorMessage(error) {
        if (error.content) {
            return this.isHtmlContent(error.content) ? ReactHtmlParser(error.content, reactParserCommonOptions()) : error.content;
        }
        return this.isHtmlContent(error.message) ? ReactHtmlParser(error.message, reactParserCommonOptions()) : error.message;
    }
    onFailure(response){
        this.response = { err: response };
        this.dispatch(Actions.setBenefitAcquiredErr(response));
        
        if (this.onClose) {
            this.onClose();
        }
        
        const err = this.response.err;
        
        if (this.benefit?.is_subsidized) {
            const status = getUpsalePopupStatus(err.status);
            AnalyticsManager.logUpsalePopupPresented(status);
            const itemsList = createAnalyticsItemsList(this.benefit.relatedBenefits, {
                item_list_name: 'upsale_popup'
            });

            AnalyticsManager.logUpsalePopupViewedItemList(itemsList);

            this.dispatchSubsidyPopup(
                this.getErrorMessage(err), 
                status,
                this.benefit,
            );
        } else {
            if (this.benefit?.relatedBenefits) {
                this.dispatchSubsidyPopup(
                    this.getErrorMessage(err) || this.translations['upsell_popup_purchase_error_title'],
                    UpsalePopupStatus.NO_INVENTORY,
                    this.benefit,
                );
            } else {
                this.dispatch(Actions.addPopup({
                    type: Popups.GENERAL_MESSAGE,
                    text: this.getErrorMessage(err),
                }));
            }
        }
    }

    handleServerError(error) {
        this.dispatch(Actions.setBenefitAcquiredErr(error));
        
        if (this.onClose) {
            this.onClose();
        }
        
        // Handle Axios errors - check if there's a response with error data
        let err = { content: error.message, status: error.status };
        
        // If there's a response with error data, use that instead
        if (error.response && error.response.data) {
            err = {
                content: error.response.data.content || error.response.data.message || error.message,
                status: error.response.data.status || error.response.status || error.status
            };
        }
        
        if (this.benefit?.is_subsidized) {
            const status = getUpsalePopupStatus(err.status);
            AnalyticsManager.logUpsalePopupPresented(status);
            const itemsList = createAnalyticsItemsList(this.benefit.relatedBenefits, {
                item_list_name: 'upsale_popup'
            });

            AnalyticsManager.logUpsalePopupViewedItemList(itemsList);

            this.dispatchSubsidyPopup(
                err.content, 
                status,
                this.benefit,
            );
        } else {
            if (this.benefit?.relatedBenefits) {
                this.dispatchSubsidyPopup(
                    err.content || this.translations['upsell_popup_purchase_error_title'],
                    UpsalePopupStatus.NO_INVENTORY,
                    this.benefit,
                );
            } else {
                this.dispatch(Actions.addPopup({
                    type: Popups.GENERAL_MESSAGE,
                    text: ReactHtmlParser(err.content, reactParserCommonOptions()),
                }));
            }
        }
    }

    dispatchSubsidyPopup(content, status, benefit) {
        const { relatedBenefits, main: { title, upsell_popup_footer_text } } = benefit;
        this.dispatch(Actions.addPopup({
            type: Popups.SUBSIDY_POPUP,
            content,
            header: title,
            benefits: relatedBenefits,
            status,
            footerText: upsell_popup_footer_text
        }));
    }

}


export default acquireCouponWeb;